.menu-cards {
  position: relative;
  border: 1px solid #ededed;
  background: #ffffff;
}

.menu-cards__title {
  margin: 0;
  padding: 8px 16px;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  background: #3dcd58;
  color: #ffffff;
  position: absolute;
  top: -4px;
  z-index: 21;
}

:host(:not([dir="rtl"])) .menu-cards__title {
  left: -6px;
}

:host([dir="rtl"]) .menu-cards__title {
  right: -6px;
}

.menu-cards__title:before {
  content: "";
  position: absolute;
  bottom: -4px;
  z-index: 22;
  border: 6px solid #007626;
  border-right-width: 3px;
  border-left-width: 3px;
  border-top-width: 2px;
  border-bottom-width: 2px;
  border-bottom-color: transparent;
}

:host(:not([dir="rtl"])) .menu-cards__title:before {
  left: 0;
  border-left-color: transparent;
}

:host([dir="rtl"]) .menu-cards__title:before {
  right: 0;
  border-right-color: transparent;
}

.menu-cards__list {
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 20px 16px;
  margin: 0;
}

.menu-cards__list *,
.menu-cards__list *::before,
.menu-cards__list *::after {
  box-sizing: inherit;
}

.menu-cards__item {
  width: 33.3%;
  list-style: none;
  padding: 12px 6px;
}

.menu-cards__list--small .menu-cards__item {
  width: 25%;
  padding-bottom: 4px;
}